import React, { useContext } from "react";

import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

import { PeriodConverter } from "@state";
import { FavoritesStoreContext } from "@state/context/favorites/FavoritesStoreContext";
import { getCurrentCulture } from "@utils";
import classNames from "classnames";
import { observer } from "mobx-react";

import { store } from "./FavoritesMenuItems";

export const FavoritesMenuItemList = observer(
	function FavoritesMenuItemList(props: {
		type: string;
		name: string;
		store: store;
	}) {
		const location = useLocation<{ period: string }>();

		const { t } = useTranslation();
		const favoritesStore = useContext(FavoritesStoreContext);

		const iconClasses = classNames(
			"nav--tertiary__icon u-icon u-icon--base",
			{
				[`u-icon--${props.type}`]:
					props.type != "events" && props.type != "tournaments",
				"u-icon--favorites": props.type == "events",
				"u-icon--favorite-tournaments--filled":
					props.type == "tournaments",
			}
		);

		return (
			<li className="nav--tertiary__item">
				<Link
					className={classNames("nav--tertiary__link", {
						"is-active": location.pathname.includes(props.type),
					})}
					to={`/${getCurrentCulture()}/sports/${
						PeriodConverter.IsPredefinedPeriod(
							props.store.periodSubMenu.selectedPeriodKey
						)
							? props.store.periodSubMenu.selectedPeriodKey
							: PeriodConverter.GetDefaultPeriod()
					}/my-favorites/${props.type}`}
					onClick={() => {
						window.scroll({ top: 0 });
					}}
					replace={true}
				>
					<span className="nav--tertiary__title nav--tertiary__title--center">
						<i className={iconClasses} />
						<span>{t(props.name)}</span>
					</span>

					{props.type == "events" && (
						<span className="nav--tertiary__counter counter counter--base">
							{favoritesStore.prematchFavoritesCount}
						</span>
					)}

					{props.type == "tournaments" && (
						<span className="nav--tertiary__counter counter counter--base">
							{favoritesStore.favoriteTournamentsCount}
						</span>
					)}
				</Link>
			</li>
		);
	}
);
